import { format } from 'date-fns';

/**
 * Parse a date-only string ("yyyy-MM-dd" or ISO string) into a local Date object
 * that preserves the intended calendar day.
 *
 * Using local noon avoids day-boundary shifts when the Date is interpreted in
 * the browser's local timezone (the widest offset is ±14 hours, so noon stays
 * on the intended day everywhere).
 */
export function parseLocalDate(dateString: string): Date {
  const datePart = dateString.split('T')[0];
  const [year, month, day] = datePart.split('-').map(Number);
  return new Date(year, month - 1, day, 12, 0, 0, 0);
}

/**
 * Format a local Date object as a date-only string "yyyy-MM-dd".
 */
export function formatLocalDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * Format a date-only string for display, preserving the intended calendar day
 * regardless of the browser's timezone.
 */
export function formatDisplayDate(dateString: string, displayFormat = 'MMM dd, yyyy'): string {
  return format(parseLocalDate(dateString), displayFormat);
}
